// extracted by mini-css-extract-plugin
module.exports = {"container":"AddOn_container__2dARO","modalWrap":"AddOn_modalWrap__3ot3p","head":"AddOn_head__Iv7Xe","content":"AddOn_content__hy221","buttons":"AddOn_buttons__2dXSN"};